import { render, staticRenderFns } from "./SessionItem.vue?vue&type=template&id=789f499a&"
import script from "./SessionItem.vue?vue&type=script&lang=js&"
export * from "./SessionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports